import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Alert, ProgressBar } from 'react-bootstrap';
import { logException } from './util/logger';
import Raven from 'raven-js';


class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // Display fallback UI and log to Raven
    this.setState({ hasError: true, isSubmittingToSentry: true }, () => {
      const eventId = logException(error, info);
      this.setState({hasError: true, isSubmittingToSentry: false, event_id: eventId});
    });
  }

  render() {
    if (this.state.hasError) {
      return this.state.isSubmittingToSentry
      ?
        <Alert bsStyle="danger">
          <h2>There was an unexpected error.</h2>
          <p>
            <ProgressBar now="100" active label="Sending Error Report..." bsStyle="danger" />
            Sending Error Report...
          </p>
        </Alert>
      :
        <Alert bsStyle="danger">
          <h2>There was an unexpected error.</h2>
          <p>
            Our engineers have been notified and will work towards a solution.
          </p>
          <p>
            If you require immediate assistance, please quote
            <strong> Event ID { ' ' }
              <code style={{ fontSize: '16px' }}>
                {' '}{ this.state.event_id }
              </code>
            </strong>
          </p>
          <p>
            <a href="#" onClick={(e) => {
              try { e.stopPropagation(); } catch (and_ignore) { /* seen it bail on click in dev, guessing `e` not valid sometimes */};
              Raven.showReportDialog({
                eventId: this.state.event_id,
                user: {
                  name: _.get(Drupal, 'settings.currentUserName', ''),
                  email: _.get(Drupal, 'settings.currentUserMail', ''),
                }
              });
            }}>
              Click here to provide additional details
            </a>
          </p>
        </Alert>
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.element.isRequired,
};

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/ErrorBoundary.jsx